import React, { PureComponent } from "react";
import Row from "../../../../common/grid/Row";
import FaPlus from "react-icons/lib/fa/plus";
import { connect } from "react-redux";
import { fetchProjects, deleteProject } from "../../../../actions/project.js";
import RenderIfUserHas from "../../../../common/roles/RenderIfUserHas.js";
import BrowserHistory from "../../../../providers/BrowserHistory.js";
import Button from "../../../../common/button/Button.js";
import Modal from "../../../../common/modal/Modal.js";
import Tabs from "../../../../common/tabs/Tabs.js";
import SearchInput from "../../../../common/input/SearchInput";
import ProjectCard from "./ProjectCard";
import Masonry from "react-masonry-component";

import "./ProjectsIndex.css";

class ProjectsIndex extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			selectedTab: "ALL",
			showModal: false,
			confirmed: false,
			projectId: null,
			filterText: ""
		};

		this.onAddNewBoxClick = this.onAddNewBoxClick.bind(this);
		this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
		this.onTabClick = this.onTabClick.bind(this);
		this.onDeleteClick = this.onDeleteClick.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	onAddNewBoxClick() {
		BrowserHistory.push("/main/projects/add");
	}

	onDeleteClick(projectId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, projectId });
	}

	onDeleteConfirm() {
		this.setState({ showModal: false, confirm: true });
		this.props.deleteProject(this.state.projectId);
	}

	onEditClick(projectId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/projects/${projectId}/edit`);
	}

	onSeeMore(projectId, e) {
		e.stopPropagation();
		BrowserHistory.push("/main/projects/" + projectId);
	}

	onTabClick(tabName) {
		this.setState({ selectedTab: tabName });
	}

	componentDidMount() {
		this.props.fetchProjects();
	}

	handleInputChange(text) {
		this.setState({ filterText: text });
	}

	render() {
		if (!this.props.projects) {
			return null;
		}

		// filter by tabs
		let content = this.props.projects;
		if (this.state.selectedTab === "APPROVED") {
			content = this.props.projects.filter(p => !p.rejected);
		} else if (this.state.selectedTab === "REJECTED") {
			content = this.props.projects.filter(p => p.rejected);
		}

		// filter by text
		content = content.filter(p =>
			p.name.toLowerCase().includes(this.state.filterText.toLowerCase())
		);

		return (
			<div className="projects-index">
				{this.state.showModal && (
					<Modal
						onConfirm={this.onDeleteConfirm}
						onCancel={() => this.setState({ confirm: false, showModal: false })}
						type={"CONFIRMATION"}
						show={this.state.showModal}
					>
						Remove project permanently?
					</Modal>
				)}
				<Row _space-between _no-align filters>
					<Tabs
						onTabClick={this.onTabClick}
						selectedTab={this.state.selectedTab}
						tabs={["ALL", "APPROVED", "REJECTED"]}
					/>

					<Row _gap-16 _no-grow _no-align filters-right>
						<SearchInput
							ph="search projects"
							onChange={this.handleInputChange}
						/>
						<RenderIfUserHas roles={["admin"]}>
							<Button
								className="btn-green space-between"
								onClick={this.onAddNewBoxClick}
							>
								<FaPlus />
								<span>ADD PROJECT</span>
							</Button>
						</RenderIfUserHas>
					</Row>
				</Row>
				{/* <Row _gap-16 _wrap> */}
				<Masonry className="masonry-container">
					{content.map(p => (
						<ProjectCard
							onEdit={this.onEditClick}
							onDelete={this.onDeleteClick}
							onSeeMore={this.onSeeMore}
							key={p.id}
							project={p}
						/>
					))}
				</Masonry>
				{/* </Row> */}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		projects: state.project.all
	};
};

export default connect(
	mapStateToProps,
	{
		fetchProjects,
		deleteProject
	}
)(ProjectsIndex);



// WEBPACK FOOTER //
// ./src/components/main/projects/index/ProjectsIndex.js